function objSort (obj) {
  var keys = Object.keys(obj).sort()
  var arr = ''
  for (let i in keys) {
    // 图片数组问题处理
    if (keys[i] === 'images') {
      for (let j = 0; j < obj[keys[i]].length; j++) {
        arr += `images[${j}]=${obj[keys[i]][j]}&`
      }
    } else {
      // 正常拼接
      arr += keys[i] + '=' + obj[keys[i]] + '&'
    }
  }
  return arr.substr(0, arr.length - 1)
}

export default objSort



// WEBPACK FOOTER //
// ./src/auth/sort.js